import React from 'react'
import { IGame } from '../../../../../../api/types/game'
import { useQuery } from '@tanstack/react-query'
import { pendingActionsQueryKey } from '../../../../../../api/queries'
import { queryPendingActions } from '../../../../../../api/queries'
import { ErrorHandler } from '../../../../../../components/ErrorHandler/ErrorHandler'
import { IAction } from '../../../../../../api/types/action'
import { fromAxiosError } from '../../../../../../context/GlobalError'
import makeStyles from '@mui/styles/makeStyles'
import { Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import { ActionApproval } from './components/ActionApproval/ActionApproval'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      zIndex: 5,
      position: 'fixed',
      bottom: '10px',
      right: '10px',
    },
  })
)

interface Props {
  game: IGame
}

export const ActionsApprovalPanel: React.FC<Props> = ({ game }) => {
  const classes = useStyles()
  const {
    isLoading,
    error,
    data: actions,
  } = useQuery<IAction[]>(pendingActionsQueryKey(game.id), () => queryPendingActions(game.id))

  return (
    <>
      <div className={classes.root}>
        <ErrorHandler loading={isLoading} error={fromAxiosError(error)}>
          {actions && actions.map(a => <ActionApproval action={a} />)}
        </ErrorHandler>
      </div>
    </>
  )
}
